import {CaseTooth} from './CaseTooth';

export class DesktopAcquireCommandsModel {
  public PatientName: string;
  public LocId: string;
  public PatientId: string;
  public enumDeviceSBId: string;
  public enumDeviceCategoryId: string;
  public PatientCaseId: string;
  public ToothList: CaseTooth[] = [];
  public UserId: string;
  public Tags: string[] = [];
  public VolumeName: string;
  public DocumentId: string;
  public DocumentFilenames: string[];
  public PrinterPath: string;
  public FolderMonitorName: string;
  public PatientNO: number;
  public PatientDOB: Date;
  public Gender: string;
  public enumDocumentTypeID: string;
}

